import { AuthProvider } from '@pankod/refine-core'
import { AxiosInstance } from 'axios'
import nookies from 'nookies'

import { API_URL } from '@/lib/constants'
import { Web3ProviderContext } from '@/model/cryptoModel'
import { NonceDto } from '@/modules/auth/user-interface/dtos/nonce.dto'
import { UserDto } from '@/modules/auth/user-interface/dtos/user.dto'

let config: { withCredentials: boolean; headers?: Record<string, string> } = { withCredentials: true }
export const authProvider = (httpClient: AxiosInstance): AuthProvider => ({
  login: async ({
    connect,
    disconnect,
  }: {
    connect: Web3ProviderContext['connect']
    disconnect: Web3ProviderContext['disconnect']
  }) => {
    try {
      const connection = await connect()
      if (connection?.connected && connection.accountId && connection.signer) {
        const wallet = connection.accountId

        /* Create nonce for user */
        const response = await httpClient.post<NonceDto>(`${API_URL}/api/post/auth/nonce`, {
          wallet,
        })

        if (response.data === null) {
          throw new Error('Verification failed')
        }

        /* Sign message */
        const signature = await connection.signMessage({ message: response.data.message })

        await httpClient.post(`${API_URL}/api/post/auth/sign-in`, {
          signature,
          wallet,
          message: response.data.message,
        })

        return Promise.resolve('/dashboard')
      }
    } catch (err) {
      await disconnect()
      const errorMessage = (err as Error)?.message ?? 'Internal error'
      alert(errorMessage)
      return Promise.reject(new Error(errorMessage))
    }
    return Promise.reject(new Error('Verification failed'))
  },
  logout: ({ disconnect }: { disconnect: Web3ProviderContext['disconnect'] }) => {
    httpClient.post(`${API_URL}/api/post/auth/sign-out`, config).then()
    disconnect().then()
    return Promise.resolve()
  },
  checkError: (error) => {
    if (error && error.statusCode === 401) {
      return Promise.reject()
    }

    return Promise.resolve()
  },
  checkAuth: async (context) => {
    if (context) {
      const cookies = nookies.get(context)
      if (Object.keys(cookies).length) {
        config = {
          ...config,
          headers: {
            Cookie: Object.entries(cookies)
              .map(([key, value]) => `${key}=${value}`)
              .join('; '),
          },
        }
      }
    }
    const user = await httpClient.get(`${API_URL}/api/get/user/me`, config)
    return user.data !== null ? Promise.resolve() : Promise.reject()
  },
  getPermissions: async () => {
    const user = await httpClient.get<UserDto | null>(`${API_URL}/api/get/user/me`)
    if (user.data !== null) {
      return Promise.resolve({ status: user.data.status, role: user.data.role })
    }
    return Promise.reject()
  },
  getUserIdentity: async () => {
    const user = await httpClient.get(`${API_URL}/api/get/user/me`, config)
    return user.data
  },
})
